<template>
    <nav id="sidebarMenu" class="bg-light sidebar d-print-none d-flex flex-column" :class="sidebarExpanded ? null : 'sidebar-collapsed'">
        <ul class="nav flex-column">
            <router-link custom v-slot="{ href, navigate, isExactActive }" v-for="(item, idx) in sidebarItems" :key="idx" :to="`/${item.path}`">
            <li class="nav-item">
                <a class="nav-link" :class="isExactActive ? 'active' : null" :href="href" @click="navigate">
                    <alzata-icon :icon="item.icon" class="sidebar-icon" fixed-width /> <span class="sidebar-label">{{item.label}}</span>
                </a>
            </li>
            </router-link>
        </ul>
        <div class="mt-auto">
            <div
                class="sidebar-toggle"
                @click="toggleSidebar"
                >
                <alzata-icon :icon="sidebarExpanded ? 'fal/chevron-double-left' : 'fal/chevron-double-right'" />
            </div>
        </div>
    </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'AlzataSideMenu',
    computed: {
        sidebarItems() {
            const routes = (this.routes || [])
                .filter(x => x.sidebarOrder != null)
                .sort((a, b) => a.sidebarOrder > b.sidebarOrder ? 1 : b.sidebarOrder > a.sidebarOrder ? -1 : 0);
            return routes;
        },
        ...mapState({
            routes: state => state.iam.routes || [],
            sidebarExpanded: state => state.sidebar.expanded,
        }),
    },
    methods: {
        ...mapActions('sidebar', ['toggleSidebar'])
    },
};
</script>